import { ComponentType } from 'react';

import { BridgeWidgetId } from '../../../models/bridge.model';
import HealthRatesWidget from './health_rates_widget.component';
import GaugesWidget from './gauges_widget.component';
import LoglyticsWidget from './loglytics_widget.component';
import DeviceChartWidget from './device_chart_widget.component';
import AffectedChartWidget from './affected_chart_widget.component';
import LogsChartWidget from './logs_chart_widget.component';

export interface BridgeWidget {
  title: string;
  minSpan: number;
  component: ComponentType<{ span: number }>;
}

export const bridgeWidgets: Record<BridgeWidgetId, BridgeWidget> = {
  [BridgeWidgetId.HealthRates]: { title: 'Health rates', minSpan: 3, component: HealthRatesWidget },
  [BridgeWidgetId.Gauges]: { title: 'Affected percentages', minSpan: 3, component: GaugesWidget },
  [BridgeWidgetId.Loglytics]: { title: 'Loglytics', minSpan: 4, component: LoglyticsWidget },
  [BridgeWidgetId.DeviceChart]: { title: 'Devices / Users', minSpan: 4, component: DeviceChartWidget },
  [BridgeWidgetId.AffectedChart]: { title: 'Affected devices', minSpan: 4, component: AffectedChartWidget },
  [BridgeWidgetId.LogsChart]: { title: 'Logs', minSpan: 4, component: LogsChartWidget },
};
